import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema} from '/vercel/path0/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/vercel/path0/markdoc/tags.js'
import * as nodes from '/vercel/path0/markdoc/nodes.js'
const functions = {};
const schema = {
tags: tags ? (tags.default || tags) : {},
nodes: nodes ? (nodes.default || nodes) : {},
functions: functions ? (functions.default || functions) : {},
...(config ? (config.default || config) : {}),
};

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ntitle: Integrate with WordPress\ndescription: Use Mendable in any WordPress website.\n---\n\nBefore install, make sure you have either signed up through our [platform](https://mendable.ai) or we have provided you with the `ANON_KEY`. Without the key, you won't be able to setup the search component.\n\n---\n\n## Floating Button Component:\n\nIn your Wordpress site go to your themes folder and find the header.html file and paste this at the top. When clicked this component expands over the whole screen.\n\n```html\n<script src=\"https://unpkg.com/@mendable/search@0.0.203/dist/umd/mendable-bundle.min.js\"></script>\n<script>\n  Mendable.initialize({\n    anon_key: 'YOUR_ANON_KEY',\n    type: 'floatingButton',\n    // all the other props for the component type\n  })\n</script>\n```\n\n## Chat Bubble Component:\nIn your Wordpress site go to your themes folder and find the header.html file and paste this at the top. The Chat Bubble is a component that appears as a floating chat icon, typically pinned to the bottom right of the screen. When clicked, it will open a dialog with Mendable Chat.\n```html\n<script src=\"https://unpkg.com/@mendable/search@0.0.203/dist/umd/mendable-bundle.min.js\"></script>\n<script>\n  Mendable.initialize({\n    anon_key: 'YOUR_ANON_KEY',\n    type: 'floatingButton',\n    // all the other props for the component type\n  })\n</script>\n```";
const filepath = "/integrations/wordpress.md";
const ast = Markdoc.parse(source);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    partials[key] = Markdoc.parse(partials[key]);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
